import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  dialogPaperSx,
  dialogTitleSx,
  primaryBtnSx,
  secondaryBtnSx,
  goldCheckboxSx,
} from "./schedulerDialogStyles";

export const ConfirmationType = {
  CHECK_IN: "checkIn",
  CHECK_OUT: "checkOut",
  CANCEL: "cancel",
  LATE: "late",
  NO_SHOW: "noShow",
};

const getConfirmationTitle = (type) => {
  switch (type) {
    case ConfirmationType.CHECK_IN:
      return "Check in";
    case ConfirmationType.CHECK_OUT:
      return "Check out";
    case ConfirmationType.CANCEL:
      return "Cancel appointment";
    case ConfirmationType.LATE:
      return "Mark late";
    case ConfirmationType.NO_SHOW:
      return "No show";
    default:
      return "Confirm";
  }
};

const getConfirmationText = (type) => {
  switch (type) {
    case ConfirmationType.CHECK_IN:
      return "Would you like to check-in this client?";
    case ConfirmationType.CHECK_OUT:
      return "Would you like to check-out this client?";
    case ConfirmationType.CANCEL:
      return "Would you like to cancel this appointment?";
    case ConfirmationType.LATE:
      return "Would you like to record this client as running late?";
    case ConfirmationType.NO_SHOW:
      return "Would you like to record a no show for this client?";
    default:
      return "";
  }
};

const ConfirmationModal = ({ onClose, onConfirm, payload }) => {
  const [markAsLate, setMarkAsLate] = useState(payload?.isLate || false);

  const handleConfirm = () => {
    onConfirm({ ...payload, isLate: markAsLate });
  };

  const open = Boolean(payload);
  if (!payload) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle sx={dialogTitleSx}>
        <Typography fontWeight={700} color="inherit">
          {getConfirmationTitle(payload.dialogType)}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2.5 }}>
        <Typography sx={{ mt: 1 }}>
          {getConfirmationText(payload.dialogType)}
        </Typography>
        {payload.dialogType === ConfirmationType.CHECK_IN && (
          <FormControlLabel
            sx={{ mt: 1.5 }}
            control={
              <Checkbox
                checked={markAsLate}
                onChange={(e) => setMarkAsLate(e.target.checked)}
                sx={goldCheckboxSx}
              />
            }
            label="Mark as late"
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2 }}>
        <Button onClick={onClose} sx={secondaryBtnSx}>
          No
        </Button>
        <Button onClick={handleConfirm} variant="contained" sx={primaryBtnSx}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
